import type { Notification } from "@shared/schema";

/**
 * Pure, unit-testable mapping from a notification to its target URL
 * (OCT-14736). Returns the exact href that `handleNotificationClick`
 * navigates to, or null if the notification has no navigation target.
 */
export function notificationHref(notification: Notification): string | null {
  if (notification.resourceType === "bill" && notification.resourceId) {
    return `/ap/bills/${notification.resourceId}`;
  }
  if (notification.resourceType === "invoice" && notification.resourceId) {
    return `/ar/invoices/${notification.resourceId}`;
  }
  if (notification.resourceType === "vendor" && notification.resourceId) {
    return `/ap/vendors/${notification.resourceId}`;
  }
  if (notification.resourceType === "automation" && notification.resourceId) {
    return "/automations";
  }
  if (notification.resourceType === "sync_hub") {
    return "/settings?section=integrations";
  }
  if (notification.resourceType === "inbound_email" && notification.resourceId) {
    return "/ap/goods-received";
  }
  if (notification.resourceType === "customer" && notification.resourceId) {
    return `/ar/customers/${notification.resourceId}`;
  }
  // PRD OCT-14938 - the auto charge run summary opens its report.
  if (notification.resourceType === "report" && notification.resourceId) {
    return `/reports/${notification.resourceId}`;
  }
  return null;
}
